import { connect } from 'react-redux';
import Final from '../components/Final';

function mapStateToProps(state) {
  return { result: state.result };
}

const FinalResult = connect(
  mapStateToProps
)(Final);

export default FinalResult;



// WEBPACK FOOTER //
// ./app/containers/FinalResult.js